import React from 'react';

const Pagination = ({ itemsPerPage, totalItems, paginate, currentPage }) => {
  const pageNumbers = [];

  for (let i = 1; i <= Math.ceil(totalItems / itemsPerPage); i++) {
    pageNumbers.push(i);
  }

  const maxPageNumbersToShow = 5;
  const halfMaxPageNumbersToShow = Math.floor(maxPageNumbersToShow / 2);

  let startPage = Math.max(1, currentPage - halfMaxPageNumbersToShow);
  let endPage = Math.min(pageNumbers.length, currentPage + halfMaxPageNumbersToShow);

  if (currentPage - halfMaxPageNumbersToShow <= 0) {
    endPage = Math.min(pageNumbers.length, maxPageNumbersToShow);
  }

  if (currentPage + halfMaxPageNumbersToShow >= pageNumbers.length) {
    startPage = Math.max(1, pageNumbers.length - maxPageNumbersToShow + 1);
  }

  const pages = pageNumbers.slice(startPage - 1, endPage);

  return (
    <div className="pagination">
      <button onClick={() => paginate(1)} disabled={currentPage === 1}>
        First
      </button>
      <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
        Prev
      </button>
      {pages.map(number => (
        <button key={number} onClick={() => paginate(number)} className={currentPage === number ? 'active' : ''}>
          {number}
        </button>
      ))}
      <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === pageNumbers.length}>
        Next
      </button>
      <button onClick={() => paginate(pageNumbers.length)} disabled={currentPage === pageNumbers.length}>
        Last
      </button>
    </div>
  );
};

export default Pagination;
